import React, { useState } from 'react';

import { Button, MasterDetailForm, Row, Widget } from '@digital/ui';
import { Modal } from 'antd';
import { FormSwitch } from '@digital/ui';
import { setMultiplosGestoresContrato } from '@app/api/contrato/contratoBase';

interface Props {
  id: string;
  onUpdate: () => any;
}

const ModalDefineMultiplosGestores = (props: Props) => {
  const { id, onUpdate} = props;
  const [exibirModal, setExibirModal] = useState(false);

  const handleCancel = () => {
    setExibirModal(false);
  };

  const handleUpdateMultiplosGestores = () => {
    setMultiplosGestoresContrato(id, MultiplosGestores).then((data)=>{
      onUpdate();
    });
  };

  const [MultiplosGestores, setMultiplosGestores] = useState<boolean>(false);

  return (
    <>
      <Button
        type="primary"
        onClick={() => { setExibirModal(true) }}>
        Definir tipo PQ
      </Button>
      <Modal title="Multiplos Gestores" width="680px" visible={exibirModal} onCancel={handleCancel} footer={null}>
        {exibirModal && (
          <MasterDetailForm
            actions={[
              <Button type="link" onClick={handleCancel} key="close">
                Cancelar
              </Button>,
              <Button type="primary" onClick={()=>{
                Modal.confirm({
                  title: '',
                  content:
                    'Ao confirmar esta opção, não será possível alterá-la mais tarde.',
                  cancelText: 'Cancelar',
                  onCancel: () => { },
                  okText: 'Confirmar',
                  onOk: () => {
                    setExibirModal(false);
                    handleUpdateMultiplosGestores();
                  },
                });
              }} key="confirmarDefine">
                Confirmar
              </Button>,
            ]}>
            <Widget>
              <Row justify={"center"} style={{textAlign: 'center', display: 'flex', justifyContent: 'center'}}>
                <FormSwitch
                  label="Multiplos Gestores?"
                  name="multiplosGestores"
                  span={4}
                  checked={MultiplosGestores}
                  onChange={e => {
                    setMultiplosGestores(e);
                  }}
                />
              </Row>
              <Row>
                <p style={{ textAlign: 'center' }}>
                  Contrato Multiplos Gestores permite a associação de mais de uma planilha de quantidade a um mesmo contrato.
                </p>
              </Row>
            </Widget>
          </MasterDetailForm>
        )}
      </Modal>
    </>
  );
};
export default ModalDefineMultiplosGestores;
